import { modalNames } from '../../../shared/configs/modal';
import { controllerModes, resultCodesMap } from '../constants';

export class SetupIntervalModalHandlers {
  constructor(controller) {
    this.controller = controller;
    this.onOk = this.onOk.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.afterClose = this.afterClose.bind(this);
  }

  onCancel() {
    this.controller.modal.closeAndKeepProps(
      modalNames.setupIntervalForRegistration
    );
  }

  onOk(values) {
    const { saveState, mode } = this.controller;

    const { status, code } = saveState.state.payload;

    if (mode.startsWith('registration')) {
      if (status === 'idle' || status === 'error') {
        saveState.save({ ...values, fnName: 'register' });
        return;
      }

      if (status === 'notAvailable' && code === resultCodesMap.roomRegistered) {
        saveState.save({ ...values, fnName: 'reRegister' });
        return;
      }

      this.onCancel();
      return;
    }

    if (mode === controllerModes.updateRegistration) {
      if (status === 'idle' || status === 'error') {
        saveState.updateRegistration(values);
        return;
      }

      this.onCancel();
      return;
    }

    if (status === 'idle' || status === 'error') {
      saveState.save({ ...values, fnName: 'reRegister' });
      return;
    }

    this.onCancel();
  }

  afterClose() {
    const { modal, saveState, reset, mode } = this.controller;
    modal.removeProps(modalNames.setupIntervalForRegistration);
    mode === controllerModes.updateRegistration ? reset() : saveState.reset();
  }

  get handlers() {
    return {
      onOk: this.onOk,
      onCancel: this.onCancel,
      afterClose: this.afterClose,
    };
  }
}
